/* eslint-disable @typescript-eslint/no-explicit-any */
import { IWXTWatchableStorage } from './IWXTWatchableStorage';

export class WXTStorageWrapper implements IWXTWatchableStorage {
  private static instance: WXTStorageWrapper;
  private storage: any;

  // Private constructor to prevent direct instantiation
  private constructor(storage: any) {
    this.storage = storage;
  }

  // Static method to get the singleton instance
  public static getInstance(storage: any): WXTStorageWrapper {
    if (!WXTStorageWrapper.instance) {
      WXTStorageWrapper.instance = new WXTStorageWrapper(storage);
    }
    return WXTStorageWrapper.instance;
  }

  async getItem(
    key: string,
    type = 'local',
  ): Promise<string | null | undefined> {
    let mType = type;
    switch (type) {
      case 'session':
        mType = 'session';
        break;
      case 'sync':
        mType = 'sync';
        break;
      case 'managed':
        mType = 'managed';
        break;
      default:
        mType = 'local';
    }
    return await this.storage.getItem(`${mType}:${key}`);
  }

  async setItem(key: string, value: string, type = 'local'): Promise<void> {
    let mType = type;
    switch (type) {
      case 'session':
        mType = 'session';
        break;
      case 'sync':
        mType = 'sync';
        break;
      case 'managed':
        mType = 'managed';
        break;
      default:
        mType = 'local';
    }
    await this.storage.setItem(`${mType}:${key}`, value);
  }

  async removeItem(key: string, type = 'local'): Promise<void> {
    let mType = type;
    switch (type) {
      case 'session':
        mType = 'session';
        break;
      case 'sync':
        mType = 'sync';
        break;
      case 'managed':
        mType = 'managed';
        break;
      default:
        mType = 'local';
    }
    await this.storage.removeItem(`${mType}:${key}`);
  }

  watch(key: string, type = 'local', callback: unknown): () => void {
    let mType = type;
    switch (type) {
      case 'session':
        mType = 'session';
        break;
      case 'sync':
        mType = 'sync';
        break;
      case 'managed':
        mType = 'managed';
        break;
      default:
        mType = 'local';
    }
    return this.storage.watch(`${mType}:${key}`, callback);
  }
}
